import styled from "styled-components";

export const AboutHero = styled.div`
  position: relative;
  padding-top: 150px;
  padding-bottom: 70px;
`;

export const AboutContainer = styled.div`
  position: relative;
  z-index: 1;
  width: 100%;
  max-width: 1300px;
  margin-right: auto;
  margin-left: auto;
  padding-right: 50px;
  padding-left: 50px;
`;

export const AboutHeading = styled.h1`
  margin-top: 0;
  margin-bottom: 24px;
  font-size: 55px;
  line-height: 1.1;
  font-weight: 700;
  text-align: center;

  @media (max-width: 991px) {
    font-size: 48px;
  }

  @media (max-width: 767px) {
    font-size: 32px;
  }
`;

export const TextWrapper = styled.div`
  max-width: 700px;
  margin-bottom: 40px;
`;

export const Subtitle = styled.div`
  font-size: 21px;
  line-height: 1.4;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.5);
  text-align: center;
`;

export const TeamSection = styled.div`
  position: relative;
  padding-top: 80px;
  padding-bottom: 80px;

  @media (max-width: 991px) {
    padding-top: 60px;
    padding-bottom: 60px;
  }
  @media (max-width: 767px) {
    padding-top: 50px;
    padding-bottom: 50px;
  }
`;

export const LargeHeading = styled.h2`
  margin-bottom: 28px;
  font-size: 60px;
  line-height: 1.1;
  font-weight: 700;
  text-align: center;

  @media (max-width: 991px) {
    font-size: 48px;
  }

  @media (max-width: 767px) {
    font-size: 32px;
  }
`;

export const TeamWrapper = styled.div`
  margin-top: 50px;
`;

export const TeamGrid = styled.div`
  display: grid;
  grid-auto-columns: 1fr;
  grid-column-gap: 40px;
  grid-row-gap: 40px;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  grid-template-rows: auto auto;

  @media (max-width: 991px) {
    grid-column-gap: 32px;
    grid-template-columns: 1fr 1fr 1fr;
  }

  @media (max-width: 767px) {
    grid-column-gap: 32px;
    grid-template-columns: 1fr 1fr;
  }

  @media (max-width: 500px) {
    grid-column-gap: 32px;
    grid-template-columns: 1fr;
  }
`;

export const TeamItem = styled.div`
  @media (min-width: 991px) {
    grid-column: ${(props) => (props.column ? props.column : "auto")};
  }
`;

export const TeamCard = styled.div``;

export const TeamProfileWrapper = styled.div`
  position: relative;
  overflow: hidden;
  margin-bottom: 24px;
  padding-top: 124%;
  border-radius: 10px;
`;

export const TeamImg = styled.img`
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

export const TeamName = styled.div`
  font-size: 20px;
  line-height: 25px;
  font-weight: 500;
`;

export const TeamRole = styled.div``;

export const TeamProfileOverlay = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 1;
  display: flex;
  padding-bottom: 20px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.72);
  opacity: 0;
  -webkit-transition: opacity 250ms;
  transition: opacity 250ms;
  color: #fff;
  line-height: 25px;
  font-weight: 500;
  text-align: center;

  :hover {
    opacity: 1;
  }
`;

export const TeamSocialLinks = styled.div`
  margin-top: 14px;
  margin-right: -8px;
  margin-left: -8px;
`;

export const HeroBanner = styled.div`
  position: relative;
  top: 0;
  left: 0;
  padding-top: 156px;
  text-align: center;
  background-color: #fbfaf6;
`;

export const HeroBannerTitle = styled.p`
  margin: 0;
  color: #125f3f;
  font-weight: 500;
  font-size: 22px;
  line-height: 24px;
  letter-spacing: -0.44px;
  @media (min-width: 1028px) {
    font-weight: 500;
    font-size: 24px;
    line-height: 48px;
    letter-spacing: normal;
  }
`;

export const HeroBannerHeader = styled.p`
  color: #0a0f1c;
  padding: 9px 33px;
  font-size: 30px;
  line-height: 30px;
  letter-spacing: -0.3px;
  @media (min-width: 472px) {
    padding: 9px 60px;
    font-size: 40px;
    line-height: 40px;
    letter-spacing: -0.4px;
  }
  @media (min-width: 930px) {
    margin: 0;
    padding: 9px 134px;
    font-size: 80px;
    line-height: 80px;
    letter-spacing: -0.8px;
  }
`;

export const BannerImageContainer = styled.div`
  padding-top: 120px;
  & > * {
    overflow: visible !important;
  }
  & > * > img {
    margin-top: 45px !important;
  }
`;

export const OurPurposeContainer = styled.div`
  margin: 0 auto;
  padding-bottom: 174px;
  width: 95%;
  & > p:not(:first-child) {
    font-size: 18px;
    line-height: 28px;
    padding-top: 20px;
    margin: 0 auto;
  }
  @media (min-width: 772px) {
    width: 80%;
    & > p:not(:first-child) {
      font-size: 20px;
      line-height: 30px;
    }
  }
`;

export const OurPurposeTitle = styled.p`
  font-weight: 500;
  color: #125f3f;
  padding: 125px 0 20px;
  font-size: 20px;
  line-height: 29px;
  text-align: center;
  @media (min-width: 772px) {
    padding-top: 145px;
    font-size: 24px;
  }
  @media (min-width: 1020px) {
    padding-top: 219px;
  }
`;

export const OurPurposeHeader = styled.p`
  margin: 0 auto;
  padding-bottom: 30px;
  text-align: center;
  font-size: 32px;
  line-height: 40px;
  letter-spacing: -0.36px;
  @media (min-width: 772px) {
    font-size: 44px;
    line-height: 52px;
    letter-spacing: -0.44px;
  }
`;

export const PurposeContentContainer = styled.div`
  ${(props) => props.middle && "max-width: 561px;"}
  height: ${(props) => (props.middle ? "537px" : "425px")};
  display: flex;
  flex-direction: column;
  justify-content: center;
  ${(props) => props.bottom && "margin-bottom: -35px;"}
  & > div:first-child {
    padding-top: 16px;
    color: white;
    font-size: 35px;
    line-height: 38.5px;
    letter-spacing: -0.35px;
  }
  @media (min-width: 1050px) {
    height: ${(props) => (props.middle ? "674px" : "634px")};
    & > div:first-child {
      font-size: 44px;
      line-height: 48.4px;
      letter-spacing: -0.44px;
    }
  }
`;

export const PurposeContentContainerMobile = styled.div`
  display: flex;
  flex-direction: column;
  /* width: 85%; */
  font-size: 30px;
  line-height: 33px;
  & > div:first-child {
    padding-top: 33px;
    color: white;
  }
  @media (min-width: 453px) {
    width: 85%;
  }
`;

export const LeadershipHeader = styled.p`
  padding: 20px 0 56px;
  font-size: 32px;
  line-height: 40px;
  letter-spacing: -0.36px;
  @media (min-width: 772px) {
    font-size: 44px;
    line-height: 52px;
    letter-spacing: -0.44px;
  }
`;

export const StatsCardContainer = styled.div`
  display: grid;
  gap: 59px 60px;
  grid-template-columns: repeat(1, 1fr);
  padding-bottom: 90px;
  margin: 0 auto;
  width: fit-content;
  @media (min-width: 580px) {
    grid-template-columns: repeat(2, 1fr);
  }
  @media (min-width: 1100px) {
    grid-template-columns: repeat(4, 1fr);
  }
`;

export const ContactText = styled.p`
  text-align: center;
  font-weight: 500;
  letter-spacing: -0.44px;
  font-size: 20px;
  line-height: 24.76px;
  @media (min-width: 420px) {
    font-size: 24px;
    line-height: 28.76px;
  }
  @media (min-width: 772px) {
    font-size: 26px;
    line-height: 32.76px;
  }
`;
